import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ModalController, ToastController } from 'ionic-angular';
import { CategoryServiceProvider } from '../../providers/category-service/category-service';
import { InventarioServiceProvider } from '../../providers/inventario-service/inventario-service';
import { Configuration } from '../../constants/config';

/**
 * Generated class for the CategoriesPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
    selector: 'page-categories',
    templateUrl: 'categories.html',
})
export class CategoriesPage {

    categoryList = [];
    categoryListAll = [];

    constructor(public navCtrl: NavController, public navParams: NavParams, public modalCtrl: ModalController, public toastCtrl: ToastController, public inventarioService: InventarioServiceProvider, public categoryService: CategoryServiceProvider, public _configuration: Configuration) {
        this.load();
    }

    /**
     * @Info Load Category list
     * @accept: parameters
     * @return: response
     * @author: sev
     * @date  : 2017-10-22
     */
    load(){
        let data = {IdCategory: 0, token: this._configuration.token};
        this.categoryService.getList(data)
            .then(data => {
                let response : any = data;
                if (!response.Error){
                    this.categoryList = response.Content;
                    this.categoryListAll = response.Content;
                    this.getItemsNumber();
                }else{
                    let toast = this.toastCtrl.create({message: response.ErrorMessage,position: 'middle',duration: 3000});
                    toast.present();
                }
            });
    }

    /**
     * @Info Get items and populate nro of items by category
     * @accept: parameters
     * @return: response
     * @author: sev
     * @date  : 2017-10-22
     */
    getItemsNumber(){
        let data = {IdItem: 0, UPC: "0", token: this._configuration.token};
        this.inventarioService.getList(data)
            .then(data => {
                let response : any = data;
                if (!response.Error){
                    let itemList = response.Content;
                    if (itemList){
                        if (itemList.length > 0) {
                            itemList.forEach(item => {
                                let category = this.categoryList.filter(function (e, i) {
                                    return e.IdCategory == item.IdCategory
                                })[0];
                                if (category.items) {
                                    category.items = category.items + 1;
                                } else {
                                    category.items = 1;
                                }
                            });
                        }
                    }
                }else{
                    let toast = this.toastCtrl.create({message: response.ErrorMessage,position: 'middle',duration: 3000});
                    toast.present();
                }
            });
    }


    /**
     * @Info Create Category
     * @accept: parameters
     * @return: response
     * @author: sev
     * @date  : 2017-10-22
     */
    create(){
        const modalData = {isEdit: false};
        let modal = this.modalCtrl.create("ModalCategoryPage", { data: modalData });
        modal.onDidDismiss(data => {
            if (data){
                if (data.reaload){
                    this.load();
                }
            }
        });
        modal.present();
    }


    /**
     * @Info Edit Category
     * @accept: parameters
     * @return: response
     * @author: sev
     * @date  : 2017-10-21
     */
    edit(category){
        const modalData = {isEdit: true, category: category};
        const modal = this.modalCtrl.create("ModalCategoryPage", {data: modalData});
        modal.onDidDismiss(data => {
            if (data){
                if (data.reaload){
                    let toast = this.toastCtrl.create({message: "Successfully applied changes",position: 'middle',duration: 3000});
                    toast.present();
                    this.load();
                }
            }
        });
        modal.present();
    }


    /**
     * @Info Show all items
     * @accept: parameters
     * @return: response
     * @author: sev
     * @date  : 2017-10-28
     */
    showAll(ev: any) {
        this.categoryList = this.categoryListAll;
    }


    /**
     * @Info Search items
     * @accept: parameters
     * @return: response
     * @author: sev
     * @date  : 2017-10-28
     */
    getItems(ev: any) {
        // set val to the value of the searchbar
        let val = ev.target.value;

        // if the value is an empty string don't filter the items
        if (val && val.trim() != '') {
            this.categoryList = this.categoryList.filter((item) => {
                return (item.Name.toLowerCase().indexOf(val.toLowerCase()) > -1);
            })
        }
    }


}


// WEBPACK FOOTER //
// ./src/pages/categories/categories.ts